/**
 * Format exchange and exchangeType for display.
 * - Exchange: Capitalize first letter (e.g. "bybit" -> "Bybit")
 * - ExchangeType: Replace "-" with space, capitalize each word (e.g. "soon-spot" -> "Soon Spot")
 */
export const formatExchangeDisplay = (
  exchange: string,
  exchangeType: string | null
): string => {
  const formattedExchange =
    exchange && exchange.length > 0
      ? exchange.charAt(0).toUpperCase() + exchange.slice(1).toLowerCase()
      : "";

  const type = exchangeType || "spot";
  const formattedType = type
    .split("-")
    .map((word) =>
      word.length > 0
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        : ""
    )
    .filter(Boolean)
    .join(" ");

  return formattedType ? `${formattedExchange} ${formattedType}` : formattedExchange;
};
